import React from 'react';
import { Navigate } from 'react-router-dom';

// Legacy /reset-password?token=XXX route — redirects to the new 6-digit-code flow.
export default function ResetPasswordPage() {
  return <Navigate to="/forgot-password" replace />;
}
